import { Component, Input, inject } from '@angular/core';
import { Router } from '@angular/router';
import { CollectiviteitData } from '@inshared/shared/core';
import { NativeRouterService, WINDOW } from '@inshared/shared/util';
import { DateService } from 'outshared-lib';

@Component({
    selector: 'ins-topbar',
    templateUrl: './topbar.component.html',
    styleUrls: ['./topbar.component.scss'],
})
export class TopbarComponent {
    @Input() collectivity: CollectiviteitData | null = null;
    @Input() authenticated: boolean | null = false;
    @Input() public useAngularRouter: boolean = false;

    public baseUrl = inject(NativeRouterService).baseUrl;
    public window = inject<Window>(WINDOW);
    public router = inject(Router);

    public scenario: object = {};
    public companyId: string = '';

    public koningsdag: boolean = false;
    public valentijn: boolean = false;

    constructor(private dateService: DateService) {
        this.checkHolidayDate();
    }

    public generateRoute(route: string): string {
        return this.useAngularRouter ? route : '';
    }

    public navigateToHome(): void {
        this.window.location.href = this.window.location.origin;
    }

    public generateUrl(route: string): string {
        return this.useAngularRouter ? '' : `${this.baseUrl}/${route}`;
    }

    private checkHolidayDate(): void {
        const day = this.dateService.day();
        const month = this.dateService.month();

        if (day === 27 && month === 4) {
            this.koningsdag = true;
        }
        if (day === 14 && month === 2) {
            this.valentijn = true;
        }
    }
}
